import React from 'react';

import { Icon as IconType } from 'iconsax-react';

interface StatisticCardData {
  title: string;
  value: number | string;
  Icon: IconType;
  formatted?: boolean;
  postfix?: string;
}
function formatNumber(numStr: number | string) {
  let str = typeof numStr === 'number' ? numStr.toString() : numStr;

  return Number(str).toLocaleString('en-US', {
    minimumFractionDigits: str.includes('.') ? str.split('.')[1].length : 0,
  });
}

export function StatisticCard({
  title,
  value,
  Icon,
  formatted,
  postfix,
}: StatisticCardData) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-xs flex items-center justify-start">
      <div className="flex items-center justify-center gap-x-4">
        <div className="bg-gray-100 p-3 rounded-xl">
          <Icon size={24} color="green" />
        </div>
        <div>
          <h3 className="text-sm font-medium text-text-secondary">{title}</h3>
          <p className="text-2xl font-bold text-light-text-primary">
            {formatted
              ? `${formatNumber(value)} ${!!postfix ? postfix : ''}`
              : `${value} ${!!postfix ? postfix : ''}`}
          </p>
        </div>
      </div>
    </div>
  );
}
